module.exports = __webpack_public_path__ + "img/m1-min.000ad226.png";